import { isMobileFunc } from '@/helper/functions';

export default function SideSheets({ title = null, children, onOpenChange, startIcon = null }) {
  const closeSheets = (e) => {
    if (e.target.id == 'sheet') {
      onOpenChange(false);
    }
  };

  const icons = {
    filter: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M29.333 8.66668H21.333"
          stroke="#242424"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00033 8.66668H2.66699"
          stroke="#242424"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3337 13.3333C15.911 13.3333 18.0003 11.244 18.0003 8.66667C18.0003 6.08934 15.911 4 13.3337 4C10.7563 4 8.66699 6.08934 8.66699 8.66667C8.66699 11.244 10.7563 13.3333 13.3337 13.3333Z"
          stroke="#242424"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.3333 23.3333H24"
          stroke="#242424"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.667 23.3333H2.66699"
          stroke="#242424"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6667 28C21.244 28 23.3333 25.9107 23.3333 23.3333C23.3333 20.756 21.244 18.6667 18.6667 18.6667C16.0893 18.6667 14 20.756 14 23.3333C14 25.9107 16.0893 28 18.6667 28Z"
          stroke="#242424"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  };

  return (
    <div
      id="sheet"
      onClick={closeSheets}
      className="z-50 bg-[#070707cc] backdrop-opacity-disabled w-screen h-[100dvh] fixed inset-0 flex items-end justify-end overflow-hidden"
    >
      <div
        className={`
            ${isMobileFunc() ? 'animate-enter-top' : `animate-enter-left`}
          flex flex-col items-center bg-white dark:bg-blackFont-800 min-w-[320px] max-sm:w-screen h-full gap-4 overflow-hidden relative
        `}
      >
        <section className="flex items-center justify-between w-full p-6 border-b-1 border-b-light-grey dark:border-b-blackFont-700">
          <div className="flex flex-row items-center gap-2">
            {startIcon && icons[startIcon]}
            <p className="text-[22px] font-semibold text-text-hard dark:text-white">{title}</p>
          </div>
          <span
            id="sheet-btn"
            onClick={() => onOpenChange(false)}
            className="w-8 h-8 transition-all flex items-center justify-center rounded-xl cursor-pointer hover:bg-light-grey/30 dark:hover:bg-blackFont-700"
          >
            <svg className="w-6 h-6 text-text-normal dark:text-white">
              <use href="#close"></use>
            </svg>
          </span>
        </section>
        <div className="flex flex-col w-full h-full">{children}</div>
      </div>
    </div>
  );
}
